module.exports = __webpack_public_path__ + "img/message_order.9dcb3545.png";